import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAction } from '../../../Common/hooks';
import { hideFlyout, setFlyoutTitle } from '../../../Dashboard/actions';
import { selectFlyoutTitle } from '../../../Dashboard/selectors';
import { selectCredentialFormMode, selectCurrentSelectedAgency } from '../../selectors';
import {
  setCredentialFormCreateMode,
  setHideCredentialForm,
  setProfileFormIsNotEditable,
} from '../../actions';
import { text } from '../../constants';

const useAgenciesFlyout = () => {
  const dispatchHideFlyout = useAction(hideFlyout);
  const dispatchIsNotEditable = useAction(setProfileFormIsNotEditable);
  const dispatchSetCredentialFormCreateMode = useAction(setCredentialFormCreateMode);
  const dispatchHideCredentialForm = useAction(setHideCredentialForm);
  const dispatchSetFlyoutTitle = useAction(setFlyoutTitle);
  const flyoutTitle = useSelector(selectFlyoutTitle);
  const formMode = useSelector(selectCredentialFormMode);
  const { agencyName } = useSelector(selectCurrentSelectedAgency);
  const keepOpen = formMode === text.createMode;

  useEffect(() => {
    dispatchSetFlyoutTitle(agencyName);
  }, [agencyName]);

  const handleOnCloseFlyout = () => {
    dispatchHideFlyout();
    dispatchIsNotEditable();
    dispatchHideCredentialForm();
    dispatchSetCredentialFormCreateMode();
  };

  return {
    handleOnCloseFlyout,
    flyoutTitle,
    keepOpen,
  };
};

export default useAgenciesFlyout;
